import { LinkPreview as UILinkPreview } from "@business-finland/wif-ui-lib/dist/LinkPreview";

import { Viewport } from "../../../constants/app";
import useImageDataHandler, {
  ImageDataHandlerFn,
} from "../../../hooks/useImageDataHandler";
import { jcrMultiFieldToArray } from "../../../util/magnolia";

interface ICard {
  id: string;
  cardTitle: string;
  cardIntroText: string;
  link: string;
  linkLabel: string;
  linkDescription: string;
  altText?: string;
  image?: Wif.Mgnl.Image;
}

interface ILinkPreview {
  type: {
    cards: Wif.Mgnl.NodeWithList<Wif.Mgnl.Node<ICard>>;
    field: string;
  };
}

export function LinkPreview(props: ILinkPreview) {
  const { type } = props;
  const imageDataHandler = useImageDataHandler();

  const cardNodes = jcrMultiFieldToArray(type.cards);
  const cards = cardNodes.map((node) =>
    mapCardNodeToLinkPreview(node, imageDataHandler)
  );
  return (
    <UILinkPreview
      hasImages={type.field === "image"}
      hasSaveButton={false}
      cards={cards}
    />
  );
}

function mapCardNodeToLinkPreview(
  node: Wif.Mgnl.Node<ICard>,
  imageDataHandler: ImageDataHandlerFn
) {
  const {
    image,
    cardTitle,
    cardIntroText,
    link,
    altText,
    linkLabel,
    linkDescription,
  } = node;

  if (!image || !altText) {
    return {
      cardTitle,
      cardIntroText,
      link,
      linkLabel,
      linkDescription,
    };
  }

  const imageProps = {
    ...imageDataHandler(image, { maxViewport: Viewport.xs }),
    altText,
    credits: image?.metadata?.rights,
  };

  return {
    imageProps,
    cardTitle,
    cardIntroText,
    link,
    linkLabel,
    linkDescription,
  };
}
